import React from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle } from 'lucide-react';

const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  loading,
  loadingLabel,
  errorMessage,
  hideConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={loading ? undefined : onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-icon">
          <AlertTriangle size={28} />
        </div>
        <p className="confirm-dialog-title">{title}</p>
        {message && <p className="confirm-dialog-message">{message}</p>}
        {errorMessage && <p className="confirm-dialog-error">{errorMessage}</p>}
        <div className="confirm-dialog-actions">
          <button className="confirm-dialog-cancel" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          {/* Hidden when the action is refused outright — only Cancel/Close remains */}
          {!hideConfirm && (
            <button className="confirm-dialog-confirm" onClick={onConfirm} disabled={loading}>
              {loading ? (
                <span className="confirm-dialog-loading">
                  <span className="confirm-dialog-spinner" />
                  {loadingLabel}
                </span>
              ) : (
                confirmLabel
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

ConfirmDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  hideConfirm: PropTypes.bool,
};

ConfirmDialog.defaultProps = {
  message: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  loading: false,
  loadingLabel: 'Processing...',
  errorMessage: '',
  hideConfirm: false,
};

export default ConfirmDialog;
